var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application",attrs:{"id":"app"}},[_c('p-header'),(_vm.isAuthenticated)?_c('main',[_c('p-shell')],1):(_vm.isReady)?_c('main',[_c('p-login')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }